export default {
  title: 'Configurações',
  subtitle: 'Conta, preferências e sessão.',
  profile: 'Perfil',
  name: 'Nome',
  email: 'E-mail',
  language: 'Idioma',
  language_hint: 'Usado na interface, em e-mails e notificações.',
  timezone: 'Fuso horário',
  saved: 'Preferências salvas.',
  sign_out: 'Sair',
  account_label: 'Conta',
  your_role: 'Seu papel',
  subscription: 'Assinatura',
  subscription_denied: 'Sem permissão para ver dados de assinatura.',
  plan: 'Plano',
  monthly: 'Mensalidade',
  state: 'Situação',
  renews_at: 'Renova em',
  subscription_empty: 'Nenhuma assinatura ativa nesta conta.',
  sign_out_confirm: 'Encerrar a sessão neste dispositivo?',
}
